module.exports = __webpack_public_path__ + "img/jiedong.a0ef3bac.png";